import { render, staticRenderFns } from "./customerBill.vue?vue&type=template&id=62afdf45&scoped=true"
import script from "./customerBill.vue?vue&type=script&lang=js"
export * from "./customerBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62afdf45",
  null
  
)

export default component.exports